import { useEffect } from 'react';

import { useLayoutPaddingContext } from './layoutPadding.context';

/**
 * Disables Layout's MainContent inline/block paddings so the current page can
 * render edge-to-edge. Automatically re-enables padding when the component
 * unmounts.
 */
export const useDisableLayoutPadding = (disabled: boolean): void => {
  const { setPaddingDisabled } = useLayoutPaddingContext();

  useEffect(() => {
    setPaddingDisabled(disabled);

    return () => {
      setPaddingDisabled(false);
    };
  }, [disabled, setPaddingDisabled]);
};
